"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var EmptyTrashSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M13,7.99752993 L12,7.99752993 L12,6 L6,6 L6,13 C6,13.5522847 6.44771525,14 7,14 L8,14 L8,15 L7,15 C5.8954305,15 5,14.1045695 5,13 L5,6 L4,6 L4,5 L7,5 L7,4 C7,3.44771525 7.44771525,3 8,3 L10,3 C10.5522847,3 11,3.44771525 11,4 L11,5 L14,5 L14,6 L13,6 L13,7.99752993 Z M8,4 L8,5 L10,5 L10,4 L8,4 Z M12.5002793,11.792184 L14.1379609,10.1553654 C14.3329264,9.96050261 14.6484266,9.95891679 14.8453412,10.1518099 C15.0393505,10.341857 15.0425624,10.6531963 14.8525152,10.8472056 L13.2009616,12.493964 L14.8523919,14.1505201 C15.0443656,14.3430896 15.0438825,14.6548235 14.851313,14.8467972 C14.656859,15.0397627 14.3442572,15.0391077 14.1514121,14.84613 L12.5002793,13.1938624 L10.8536662,14.8456979 C10.6611302,15.0388446 10.3485823,15.0396932 10.1550002,14.8475947 C9.96175077,14.6558264 9.96055013,14.3437077 10.1523185,14.1504582 L11.799597,12.493964 L10.147208,10.8508471 C9.9548889,10.6596071 9.95401406,10.3486711 10.145254,10.156352 L10.1498303,10.1518099 C10.3468218,9.95884143 10.6623808,9.96021422 10.8576859,10.1548893 L12.5002793,11.792184 Z" })));
};
EmptyTrashSmall.displayName = 'EmptyTrashSmall';
exports.default = EmptyTrashSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=EmptyTrashSmall.js.map